module.exports = __webpack_public_path__ + "static/media/TealButtonMask.45377a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Masks/TealButtonMask.png
// module id = 36
// module chunks = 0